import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1915473c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basePageWraper pagefull" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"centerWrap\" data-v-1915473c><section class=\"hero is-link width100\" data-v-1915473c><div class=\"hero-body\" data-v-1915473c><p class=\"title has-text-left\" data-v-1915473c> 기본 빈페이지 </p><p class=\"subtitle has-text-left\" data-v-1915473c> 내용을 넣습니다. </p></div></section><div class=\"cont\" data-v-1915473c><div data-v-1915473c>page is empty</div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}